import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import Assessments from "Gradebook/routes/Assessments";
import LearningGoals from "Gradebook/routes/LearningGoals";
import Standards from "Gradebook/routes/Standards";
import FinalGrades from "Gradebook/routes/FinalGrades";
import { injectReducer } from "store/reducers";

export default store => ({
  path: ":courseId",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-gradebook" */ "./components"),
        import(
          /* webpackChunkName: "learning-course" */ "LearningCourse/modules/LearningCourseModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;

        const reducer = importedModule1.default;

        if (reducer) {
          injectReducer(store, {
            key: "learningCourse",
            reducer,
          });
        }

        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    Assessments(store),
    LearningGoals(store),
    Standards(store),
    FinalGrades(store),
  ],
});
